export const getOffer = (state, { applicationId }) => (state.form.offer.offers[applicationId]);
export const getOfferFile = (state, { applicationId }) => (state.form.offer.files[applicationId]);
